import { IEvento } from "@/interfaces/evento.interface";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface InscricoesState {
  Eventos: Array<IEvento>;
}

const initialState: InscricoesState = {
  Eventos: [],
};

export const inscricoesSlice = createSlice({
  name: "inscricoes",
  initialState,
  reducers: {
    SetEventos(
      state: InscricoesState,
      { payload }: PayloadAction<Array<IEvento>>,
    ) {
      state.Eventos = payload;
    },
  },
});

export const { SetEventos } = inscricoesSlice.actions;
export const inscricoesReducer = inscricoesSlice.reducer;
